import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import BasketSummaryDetailsTemplate from './BasketSummaryDetailsTemplate';
import { rem } from 'polished';
import { isMarketIT } from '../../constants/main';

export const BasketSummaryDetailsStyled = styled(BasketSummaryDetailsTemplate)`
    padding: ${rem(32)};

    @media (min-width: ${breakpoints.md}px) {
        position: sticky;
        top: ${({ isTopMargin }) => (isTopMargin ? rem(72) : rem(30))};
    }

    .offerValidityDate {
        display: flex;
        align-items: center;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        margin-bottom: ${rem(10)};

        .tooltip button {
            background: none;
            border: none;
            margin-left: ${rem(4)};
            margin-bottom: -${rem(2)};
            cursor: pointer;
        }
    }

    .prices {
        max-height: calc(100vh - 145px);
        overflow: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            display: none;
        }

        @media (max-width: ${breakpoints.md}px) {
            max-height: 100% !important;
        }
    }

    .title {
        font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.black};
        padding-bottom: ${rem(30)};
        background: #f5f5f5;
        z-index: 1000;
        padding-top: ${rem(10)};

        @media (min-width: ${breakpoints.md}px) {
            top: ${rem(55)};
        }

        .closeIcon {
            position: absolute;
            right: ${rem(10)};
            top: ${rem(10)};
            cursor: pointer;
        }

        .label {
            display: flex;
            justify-content: space-between;

            svg {
                width: ${rem(26)};
                height: ${rem(26)};
                cursor: pointer;
            }
        }
    }

    .priceSection {
        padding: ${rem(13)} 0;
        border-top: 1px solid ${({ theme }) => theme.colors.grey30};
        font-size: ${({ theme }) => theme.fontSizes.textBase};

        &_title {
            text-transform: uppercase;
            padding-bottom: ${rem(10)};
        }

        &_value {
            display: flex;
            justify-content: space-between;
            padding-bottom: ${rem(5)};

            .value {
                width: ${rem(100)};
                text-align: right;
            }
        }

        &.withoutPadding {
            padding-bottom: 0;
        }
    }

    .promoCodeResult,
    .dealerDiscountResult {
        padding: ${rem(13)} 0;
        border-top: 1px solid ${({ theme }) => theme.colors.grey30};
        font-size: ${({ theme }) => theme.fontSizes.textBase};

        .promoCode__content {
            padding: 0;
        }

        .result {
            width: 80%;
        }

        .price {
            width: 25%;
            text-align: right;
        }
    }

    .dealerDiscountResult {
        display: flex;
        justify-content: space-between;
    }

    .storePrice {
        padding: ${rem(13)} 0;
        border-top: 1px solid ${({ theme }) => theme.colors.grey30};
        font-size: ${({ theme }) => theme.fontSizes.textBase};

        &_value {
            display: flex;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            justify-content: space-between;
            padding-bottom: ${rem(8)};

            &_price {
                width: ${rem(200)};
                text-align: right;
                white-space: nowrap;
            }
        }

        &_link {
            text-align: right;
            text-decoration: underline;
            cursor: pointer;
            background: none;
            border: none;
            padding: 0;
            width: 100%;
            text-align: right;
        }
    }

    .totalPrice {
        padding: ${rem(19)} 0;
        border-top: 1px solid ${({ theme }) => theme.colors.grey30};
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey30};
        position: relative;

        &_section {
            display: flex;
            justify-content: space-between;
        }

        &_title {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};

            &.noWrap {
                white-space: nowrap;
            }
        }

        &_cashPrice {
            text-align: right;
            font-size: ${rem(16)};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            white-space: nowrap;
            padding-bottom: ${rem(2)};

            &.isCash {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
            }

            &.isShowPriceExcludedVAT {
                margin-top: ${rem('10px')};
            }

            &_label {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                text-align: right;
                padding-top: ${rem(4)};
            }
        }

        &_monthlyPrice {
            padding-top: ${isMarketIT ? rem(8) : rem(4)};
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            position: relative;
            display: flex;
            justify-content: space-between;

            &_title {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            &_price {
                text-align: right;
            }

            .formatted {
                white-space: nowrap;
                padding-right: ${rem(3)};
            }

            .prefix,
            .suffix {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
            }

            .prefix {
                padding-right: ${rem(3)};
            }
        }

        &_label {
            text-align: right;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            padding-top: ${rem(4)};

            .promotionalTextWrapper {
                display: flex;
                flex-direction: column;
            }
        }

        &_link {
            text-align: right;
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            text-decoration: underline;
            cursor: pointer;
            background: none;
            border: none;
            padding: ${rem(8)} 0 0 0;
            width: 100%;
            text-align: right;
        }
    }

    .promoCodeSection {
        padding: ${rem(15)} 0 ${rem(20)} 0;
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey30};
        margin-bottom: ${rem(20)};

        button {
            background: none;
            border: none;
            padding: ${rem(5)} 0;
        }

        &_title {
            padding-bottom: ${rem(8)};
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            cursor: pointer;

            span {
                margin-right: ${rem(3)};
            }

            &.isHide {
                svg {
                    transform: rotate(180deg);
                }
            }

            svg {
                margin-left: ${rem(3)};

                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .promoCode {
            &__input_container {
                @media (min-width: ${breakpoints.sm}px) {
                    width: 60%;
                }
            }

            &__input_label_error {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                padding: ${rem(10)} 0;
            }

            &__input_label_success {
                width: 100%;
                color: ${({ theme }) => theme.colors.black};
                background: unset;
                position: relative;
                left: 0;
                text-align: left;
                padding: ${rem(10)} 0;
                margin: 0;
                top: unset;
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                display: block;

                &::after {
                    border-top: unset;
                }
            }

            &__button {
                height: ${rem(50)};
                border: 1px solid ${({ theme }) => theme.colors.black};
                padding: 0 ${rem(20)} !important;

                &.isLoading {
                    background: ${({ theme }) => theme.colors.black};
                }

                &:hover:enabled {
                    background: ${({ theme }) => theme.colors.black};
                    border-color: ${({ theme }) => theme.colors.black};
                    color: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }

    .pxSection {
        margin: ${rem(13)} 0;
        background: ${({ theme }) => theme.colors.white};
        padding: ${rem(10)};
        font-size: ${({ theme }) => theme.fontSizes.textBase};

        &.withoutBackground {
            background: unset;
            padding: 0 0 ${rem(15)} 0;
            margin-top: 0;
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey30};
        }

        &_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: ${rem(5)};
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};

            .link {
                text-decoration: underline;
                cursor: pointer;
                background: none;
                border: none;
                padding: 0;
                display: flex;
                align-items: center;

                svg {
                    width: ${rem(22)};
                    height: ${rem(22)};
                    margin-bottom: ${rem(-2)};
                    margin-left: ${rem(5)};
                }
            }
        }

        &_value {
            display: flex;
            justify-content: space-between;
            padding-top: ${rem(5)};
        }

        &_status {
            padding: ${rem(10)};
            position: relative;
            padding-left: ${rem(50)};

            &__icon {
                svg {
                    position: absolute;
                    width: ${rem(30)};
                    height: ${rem(30)};
                    left: ${rem(8)};
                    top: ${rem(25)};
                }
            }
          
            &__description {
                line-height: ${rem(18)};
            }

            &__label {
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                line-height: ${rem(18)};
            }
          
            button {
                width: 80%;
                margin-left: calc(10% - 25px);
            }
        }
    }

    .isLoading {
        background: ${({ theme }) => theme.colors.black};
        color: ${({ theme }) => theme.colors.white};
    }

    .totalPriceLoading {
        flex-direction: row;
    }

    .infoIcon {
        display: inline-block;

        .vertical {
            margin: 0 0 0 ${rem(10)};
        }

        svg {
            g {
                circle,
                line {
                    stroke: ${({ theme }) => theme.colors.primary};
                }
            }
        }
    }

    .ecoBonusWrapper {
        padding: ${rem(13)} 0;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        display: flex;
        justify-content: space-between;
        align-items: baseline;

        button {
            border: unset;
        }

        &_price {
            min-width: fit-content;
            white-space: nowrap;
        }

        &_description {
            border-bottom: 1px solid ${({ theme }) => theme.colors.grey30};
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            &--opened {
                padding-bottom: ${rem(13)};
            }
        }

        &_icon {
            position: relative;
            top: ${rem(4)};
            left: ${rem(5)};
        }
    }

    .continueSection {
        margin-top: ${rem(32)};
        position: sticky;
        bottom: ${rem(12)};
        width: calc(100% + ${rem(96)});
        margin-left: -${rem(48)};
        padding: ${rem(12)} ${rem(48)} 0 ${rem(48)};

        &.withBorderTop {
            border-top: 1px solid ${({ theme }) => theme.colors.grey30};
        }
    }
`;
